import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { postLoginAsync } from "../Redux/authSlice";
import baseApi from "../Http/baseApi";
import { LOGO_MICRO, LOGO_PRIMARY } from "../utils/assetPaths";

export default function Login(props) {
  const navigation = useNavigate();

  const [modal, setModal] = useState(false);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [user_type, setUserType] = useState("");
  const [loading, setLoading] = useState(false);
  const { isLoggedIn } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const isPhonePasswordLogin =
    user_type === "Doctor" || user_type === "Patient";

  useEffect(() => {
    console.log("Login page");
  }, [dispatch]);

  const handleLogin = async (accept_terms) => {
    if (user_type === "" || user_type === "0") {
      return toast.error("Select User Type");
    }
    if (phone === "") {
      return toast.error("Enter Phone No");
    }
    if (password === "") {
      return toast.error(
        isPhonePasswordLogin
          ? "Enter Registered Phone as Password"
          : "Enter Password"
      );
    }

    if (accept_terms !== 1) {
      try {
        const response = await baseApi.post("auth/signin", {
          user_type,
          phone,
          password,
          accept_terms: 0,
        });

        if (response.data?.accept_terms === 0) {
          setModal(true);
          return;
        }

        accept_terms = 1;
      } catch (err) {
        toast.error(
          err.response?.data?.message || "Invalid credentials. Please try again."
        );
        return;
      }
    }

    setLoading(true);
    dispatch(
      postLoginAsync({
        payload: {
          phone,
          password,
          user_type,
          accept_terms: 1,
        },
      })
    )
      .unwrap()
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  if (isLoggedIn) {
    const user = JSON.parse(localStorage.getItem("userData"));
    // console.log("User Data", user);
    // console.log("User Specific Data", user.user.user_type.name);
    if (user.panel === "Admin") {
      return <Navigate to="/admin-dashboard" />;
    }
    if (user.panel === "Doctor") {
      return <Navigate to="/doctor-dashboard" />;
    }
    if (user.panel === "Patient") {
      return <Navigate to="/patient-dashboard" />;
    }
  }

  return (
    <div className="auth-page hold-transition theme-primary bg-img">
      {modal && (
        <div className="auth-modal-backdrop" role="dialog" aria-modal="true">
          <div className="auth-modal">
            <div className="auth-modal__header">
              <h5 className="auth-modal__title">CONSENT</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => {
                  setModal(false);
                }}
              ></button>
            </div>
            <div className="auth-modal__body">
              {user_type === "Doctor" ? (
                <>
                  <h4 style={{ textAlign: "center" }}>
                    Role of Home BP Monitoring in Diagnosis and Management of
                    Hypertension in India
                  </h4>
                  <hr />
                  <h3 style={{ textAlign: "center", color: "red" }}>
                    IN HOME Study
                  </h3>
                  <p>
                    I am pleased to give my consent to participate in the IN
                    HOME study and agree to conduct the study in accordance
                    with the protocol.
                  </p>
                </>
              ) : (
                <>
                  <h3 style={{ textAlign: "center", color: "red" }}>
                    WELCOME!
                  </h3>
                  <p>
                    I voluntarily agree to take part in the Home Blood
                    Pressure Screening Program. The program is explained to me
                    in a language in which I am fluent and comfortable. I have
                    had a chance to ask questions and they have been answered.
                    I understand that my identity will not be revealed in any
                    information released for publishing and will be kept
                    confidential.
                  </p>
                </>
              )}
            </div>
            <div className="auth-modal__footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  handleLogin(1);
                }}
              >
                I Agree and Proceed to Login
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                  setModal(false);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="auth-page__container">
        <div className="auth-page__inner">
          <div className="auth-card">
            <div className="auth-card__header">
              <img
                src={LOGO_PRIMARY}
                alt="HFI Logo"
                className="auth-card__logo auth-card__logo--primary"
              />
              <img
                src={LOGO_MICRO}
                alt="MicroLab"
                className="auth-card__logo auth-card__logo--secondary"
              />
            </div>

            <div className="auth-card__title">
              <h2 className="text-primary">Login</h2>
              <p>Sign in to continue</p>
            </div>

            <div className="auth-card__body">
              <div className="form-group">
                <label className="form-label">Login Type</label>
                <select
                  className="form-select"
                  name="user_type"
                  value={user_type}
                  onChange={(e) => {
                    setUserType(e.target.value);
                    setPassword("");
                  }}
                >
                  <option value="0">Select User Type</option>
                  <option value="Admin">Admin</option>
                  <option value="Doctor">Doctor</option>
                  <option value="Patient">Patient</option>
                </select>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <span className="input-group-text bg-transparent">
                    <i className="ti-user"></i>
                  </span>
                  <input
                    type="text"
                    name="phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className="form-control ps-15 bg-transparent"
                    placeholder="Registered Phone No"
                    autoComplete="username"
                  />
                </div>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <span className="input-group-text bg-transparent">
                    <i className="ti-lock"></i>
                  </span>
                  <input
                    type="password"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-control ps-15 bg-transparent"
                    placeholder={
                      isPhonePasswordLogin
                        ? "Registered Phone No (as password)"
                        : "Enter Your Password"
                    }
                    autoComplete="current-password"
                  />
                </div>
              </div>

              <div className="auth-card__actions">
                <div className="auth-card__forgot">
                  <Link to="/forgot-password" className="hover-warning">
                    <i className="ion ion-locked"></i> Forgot password?
                  </Link>
                </div>

                <div className="auth-card__submit">
                  {user_type !== "Admin" && (
                    <button
                      type="button"
                      className="auth-btn btn btn-primary"
                      onClick={() => handleLogin()}
                      disabled={loading}
                    >
                      {loading ? "SIGNING IN..." : "SIGN IN"}
                    </button>
                  )}

                  {user_type === "Admin" && (
                    <button
                      type="button"
                      className="btn auth-btn btn-primary"
                      onClick={() => {
                        handleLogin(1);
                      }}
                      disabled={loading}
                    >
                      {loading ? "SIGNING IN..." : "ADMIN SIGN IN"}
                    </button>
                  )}
                </div>
              </div>

              <div className="auth-card__footer">
                <p>
                  Don&apos;t have an account?
                  <Link
                    to="/doctor-registration"
                    className="text-warning ms-2"
                  >
                    Sign Up
                  </Link>
                </p>
                <p>
                  <Link to="/privacy-policy" className="text-warning">
                    Privacy Policy
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
